import { render, staticRenderFns } from "./check-department-single.vue?vue&type=template&id=168d5e5c&"
import script from "./check-department-single.vue?vue&type=script&lang=js&"
export * from "./check-department-single.vue?vue&type=script&lang=js&"
import style0 from "./check-department-single.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports